import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography } from '@mui/material';
import { Footer, SidePanel } from 'components/custom';
import PrimaryImage from 'public/img/side_panel_bg_primary.svg';
import SecondaryImage from 'public/img/side_panel_bg_secondary.svg';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet, useSearchParams } from 'react-router-dom';
import { isInIframe } from 'utils/iframe';
import { EMAIL_VERIFICATION, LOGIN, REGISTRATION } from 'utils/links';
import { useResponsiveness } from 'utils/responsiveness';
import { useSidebarLayoutStyles } from './styles';
const SidebarLayout = ({ variant }) => {
    const { t } = useTranslation('sidebar');
    const { isExtraSmallViewport } = useResponsiveness();
    const [searchParams] = useSearchParams();
    const inIframe = isInIframe();
    const [popupBlocked, setPopupBlocked] = useState(false);
    const getLayoutDirection = () => {
        if (!isExtraSmallViewport) {
            return 'row';
        }
        if (variant === 'login') {
            return 'column';
        }
        return 'column-reverse';
    };
    /**
     * Opens a popup window for SSO login when in iFrame mode.
     * Reads login_challenge from URL and opens the popup with the callback URL.
     */
    const handleIframeLogin = () => {
        const loginChallenge = searchParams.get('login_challenge');
        const callbackUrl = `${window.location.origin}/auth/iframe-callback`;
        const popup = window.open(`/login?login_challenge=${loginChallenge ?? ''}&return_to=${encodeURIComponent(callbackUrl)}&popup=true`, 'skylaSSO', 'width=600,height=700');
        if (!popup) {
            setPopupBlocked(true);
        }
    };
    const { formStyles } = useSidebarLayoutStyles();
    return (_jsxs(Box, { sx: {
            display: 'flex',
            flexDirection: 'column',
            minHeight: '100vh',
            minWidth: '100vw',
            position: 'relative',
        }, children: [_jsxs(Box, { sx: {
                    alignItems: 'center',
                    display: 'flex',
                    flexDirection: getLayoutDirection(),
                    flexGrow: 1,
                }, children: [variant === 'registration' && (_jsx(SidePanel, { backgroundColor: "primary.main", backgroundImage: `url(${SecondaryImage})`, slogan: t('body.registration.sidePanel.slogan'), title: t('body.registration.sidePanel.title'), buttonProps: inIframe
                            ? {
                                children: 'Bei Skyla anmelden',
                                color: 'secondary',
                                onClick: handleIframeLogin,
                            }
                            : {
                                children: t('body.registration.sidePanel.button'),
                                color: 'secondary',
                                href: REGISTRATION,
                            }, linkProps: inIframe
                            ? undefined
                            : {
                                align: 'center',
                                children: t('body.registration.sidePanel.link'),
                                color: 'common.white',
                                href: EMAIL_VERIFICATION,
                            } })), inIframe && variant === 'registration' && popupBlocked && (_jsx(Box, { sx: {
                            alignItems: 'center',
                            display: 'flex',
                            flexGrow: 1,
                            justifyContent: 'center',
                            p: 4,
                        }, children: _jsx(Typography, { variant: "body2", color: "error", children: "Popup wurde blockiert. Bitte erlauben Sie Popups f\u00FCr diese Seite." }) })), _jsx(Box, { sx: {
                            display: inIframe && variant === 'registration' ? 'none' : 'flex',
                            flexGrow: formStyles.flexGrow,
                            margin: 'auto',
                            maxWidth: '45rem',
                            minWidth: '20rem',
                            py: formStyles.py,
                            width: '50%',
                        }, children: _jsx(Outlet, {}) }), variant === 'login' && (_jsx(SidePanel, { backgroundColor: "secondary.main", backgroundImage: `url(${PrimaryImage})`, slogan: t('body.login.sidePanel.slogan'), title: t('body.login.sidePanel.title'), buttonProps: {
                            children: t('body.login.sidePanel.button'),
                            color: 'primary',
                            href: LOGIN,
                        } }))] }), _jsx(Footer, {})] }));
};
export default SidebarLayout;
